import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_51514ef0: FaireBrandEntity = {
  token: "b_51514ef0",
  type: "brand",
  name: "The Original MakeUp Eraser",
  avatarUrl:
    "https://cdn.faire.com/fastly/ec4044e81e51d83d325437d7258b19b80265f559d93a567ed7c6f4aadb57fb36.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b2b3810b6331899ca83b9d53e36f04775e0bed029769223fef9ab92949a88c08.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ec4044e81e51d83d325437d7258b19b80265f559d93a567ed7c6f4aadb57fb36.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b2b3810b6331899ca83b9d53e36f04775e0bed029769223fef9ab92949a88c08.jpeg",
  location: "San Ramon, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 736,
  isTopShop: true,
  isInsider: true,
  description:
    "Our Mission: The Original MakeUp Eraser® is dedicated to innovating sustainable solutions for your daily beauty routines. What began as an effort to eliminate single-use wipes from our planet evolved into our current-day mission to erase all the waste we see in everyday beauty product use. Our goal? To transform your routines into experiences that are eco-friendly, efficient, elevated, & impeccably clean.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:55.922Z",
    importedBy: "entity-db-cli",
  },
};
